module.exports = __webpack_public_path__ + "static/media/tot.21713ef0.svg";